import React, { Component, Fragment } from 'react';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';

import { MdLock as SecureIcon } from 'react-icons/md';
import ReactMarkdown from 'react-markdown/with-html';

import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';
import { hostIsBoardwalk, hostIsCapreit } from 'helpers/CurrentWindowLocation';
import { deepDiver } from 'helpers/utilities';

const StyledMarkdown = styled(ReactMarkdown)`
  &h4 {
    text-align: justify;
    marginbottom: 15px;
  }
  &p {
    textalign: justify;
    marginbottom: 15px;
  }
`;

const StyledH4 = styled.h4`
  text-align: center;
`;

const StyledP = styled.p`
  text-align: justify;
`;

export default withMobileDialog()(
  class PadAgreementDialog extends Component {
    state = {
      terms: null,
    };
    componentDidMount() {
      this.fetchBwalkTerms();
      this.fetchCapreitTerms();
    }

    fetchBwalkTerms = () => {
      if (!hostIsBoardwalk()) return;
      const locale = getCurrentLocale();
      const termsConditionsMD = require(`assets/localization/tenantPortal/${locale}.default.bwalkAutopayTermsConditions.md`);
      fetch(termsConditionsMD)
        .then(response => response.text())
        .then(text => {
          this.setState({
            terms: text,
          });
        });
    };

    fetchCapreitTerms = () => {
      if (!hostIsCapreit()) return;
      const { tenant_province } = this.props.tenantOverview;
      const locale = getCurrentLocale();
      let type = 'default';
      if (tenant_province && tenant_province.toLowerCase() === 'quebec') {
        type = 'quebec';
      }
      const termsConditionsMD = require(`assets/localization/tenantPortal/${locale}.${type}.capreitPadTermsConditions.md`);
      fetch(termsConditionsMD)
        .then(response => response.text())
        .then(text => {
          let fullLandlordName = 'CAPREIT LIMITED PARTNERSHIP';
          let landlordName = 'CAPREIT';
          if (this.props.tenantOverview.landlord_name === 'RPMS') {
            fullLandlordName = 'RPMS Property Management Services Inc.';
            landlordName = 'RPMS';
          }
          this.setState({
            terms: text
              .replace('{fullLandlordName}', fullLandlordName)
              .replace('{landlordName}', landlordName),
          });
        });
    };

    render() {
      let closeBtnVerbiage = getTranslatedString('close');
      if (featureEnabled('external_autopay')) {
        closeBtnVerbiage = getTranslatedString('autopay.back');
      }
      return (
        <Dialog
          fullScreen={this.props.fullScreen}
          open={this.props.isOpen}
          onClose={this.toggleSurveyDialog}
          aria-labelledby="add-new-survey"
          classes={{
            paper: 'form-dialog',
          }}
        >
          {this.renderAutopayTerms()}
          {this.renderBoardwalkTerms()}
          {this.renderCapreitTerms()}
          <DialogActions style={{ display: 'block' }}>
            <FlatButton
              onClick={this.props.handleBackAutopayStep}
              id="close-button"
              style={{ color: AccentColor() }}
            >
              {closeBtnVerbiage}
            </FlatButton>
            <FlatButton
              variant="raised"
              onClick={this.props.onSubmit}
              disabled={this.props.isLoading}
              id="submit-button"
              style={{
                color: 'white',
                backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
              }}
            >
              {getTranslatedString('iAgree')}
            </FlatButton>
          </DialogActions>
        </Dialog>
      );
    }

    renderAutopayTerms() {
      if ((hostIsBoardwalk() || hostIsCapreit()) && this.state.terms) return null;
      const absorb_monthly_pad_fee = deepDiver(this.props.tenantOverview, 'absorb_monthly_pad_fee');

      const landlordAbsorbFeesVerbiage = absorb_monthly_pad_fee
        ? getTranslatedString('padAgreement.landlordWillBeCoveringServiceFee')
        : getTranslatedString('padAgreement.feePerTransactionWillBeAdded', {
            processingFee: this.props.processingFee,
          });
      return (
        <Fragment>
          <DialogTitle id="add-new-survey">
            <h3 style={{ textAlign: 'center', margin: 0 }}>
              {getTranslatedString('padAgreement.autopayAgreement')}
            </h3>
          </DialogTitle>
          <DialogContent>
            <p style={{ fontSize: '13px', textAlign: 'justify' }}>
              {' '}
              {getTranslatedString('padAgreement.yourLandlordIsExcited')}
              {this.renderAdditionalVerbiage()}
              {getTranslatedString('padAgreement.yuhuAutopayAllowsYouTo')}{' '}
            </p>
            <div className="row" style={{ textAlign: 'center', margin: '10px 0' }}>
              <SecureIcon size={24} style={{ fontFamily: 'Circular-Black', margin: 'auto' }} />
            </div>
            <h3 style={{ textAlign: 'center', margin: 0 }}>
              {getTranslatedString('padAgreement.secureAndEasiest')}
            </h3>
            <div className="row">
              <h1 style={{ fontFamily: 'Circular-Black', textAlign: 'center', margin: '10px 0' }}>
                {' '}
                -{' '}
              </h1>
            </div>
            <p style={{ fontSize: '13px', textAlign: 'justify' }}>
              {getTranslatedString('padAgreement.iAuthorize')}
              {landlordAbsorbFeesVerbiage}
            </p>
            <p style={{ fontSize: '13px', textAlign: 'justify' }}>
              {getTranslatedString('padAgreement.iCertify')}
            </p>
            <p style={{ fontSize: '13px', textAlign: 'justify' }}>
              {getTranslatedString('padAgreement.authorityToRemainInEffect')}
            </p>
            <p style={{ fontSize: '13px', textAlign: 'justify' }}>
              {getTranslatedString('padAgreement.mayObtainASampleCancellationForm')}
            </p>
            <p style={{ fontSize: '13px', textAlign: 'justify' }}>
              {getTranslatedString('padAgreement.yuhuMayNotAssign')}
            </p>
            <p style={{ fontSize: '13px', textAlign: 'justify' }}>
              {getTranslatedString('padAgreement.haveRecourseRights')}
            </p>
          </DialogContent>
        </Fragment>
      );
    }

    renderBoardwalkTerms() {
      if (!hostIsBoardwalk() || !this.state.terms) return null;

      const { tenant_province } = this.props.tenantOverview;
      let nsfFee = null;

      if (tenant_province && tenant_province === 'Ontario') {
        nsfFee = 20;
      } else if (tenant_province && tenant_province === 'Quebec') {
        nsfFee = 50;
      } else if (tenant_province && tenant_province === 'Alberta') {
        nsfFee = 45;
      } else if (tenant_province && tenant_province === 'Saskatchewan') {
        nsfFee = 45;
      }

      return (
        <Fragment>
          <DialogTitle id="add-new-survey">
            <h3 style={{ textAlign: 'center', margin: 0 }}>
              {getTranslatedString('padAgreement.autopayAgreement')}
            </h3>
          </DialogTitle>
          <DialogContent>
            {nsfFee && (
              <Fragment>
                <StyledH4>{getTranslatedString('padAgreement.nsfFees')}</StyledH4>
                <StyledP>
                  {getTranslatedString('padAgreement.nsfFeesDescription', { nsfFee: nsfFee })}
                </StyledP>
              </Fragment>
            )}
            <StyledH4>{getTranslatedString('padAgreement.termsConditions')}</StyledH4>
            <StyledMarkdown source={this.state.terms} escapeHtml={false} />
          </DialogContent>
        </Fragment>
      );
    }

    renderCapreitTerms() {
      if (!hostIsCapreit() || !this.state.terms) return null;

      return (
        <Fragment>
          <DialogContent>
            <StyledMarkdown source={this.state.terms} escapeHtml={false} />
          </DialogContent>
        </Fragment>
      );
    }

    renderAdditionalVerbiage() {
      if (!!this.props.isApplication) {
        return getTranslatedString('padAgreement.uponAcceptance');
      }
      return '';
    }
  }
);
